<template>
  <a
    class="underline break-words"
    href="mailto:kunne@universitetsforlaget.no"
    >Ta kontakt med oss på kunne@universitetsforlaget.no</a
  >
</template>
